$(function () {
	$(".headline-type-links:not(.active)").hover(function () {	
		$('.headline-type-links.active').addClass('hover');
	}, function () {
	    $('.headline-type-links.active').removeClass('hover');
	});

	$('body').on('click', '.load-more-btn', function(e){
		if( $(this).data('action') == 'more' ){
			$(this).data('action', 'less');
			$(this).html('Show Less');
			$('.single-article').removeClass('d-none');
		}else{
			$(this).data('action', 'more');
			$(this).html('Load More');
			$('.single-article:nth-child(n+7)').addClass('d-none');
		}
	});

	$('body').on('change paste keyup', '#keyword', function(e){
		$('.article-search-results-wrap').removeClass('display-result');
	});

	$('body').on('click', '.search-btn', function(e){
		$('.article-search-results').html('');
		$('.article-search-results-wrap').removeClass('display-result');
		var keyword = $('#keyword').val();
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var data = {
			'_token': csrf_token,
            'keyword': keyword,
		};

        $.ajax({
        	type: 'POST',
        	url: "/headlines/search-article",
        	data: data,
			success: function(data){
				$('.article-search-results-wrap').addClass('display-result');
				$.each(data, function(k, v){
					if( k == 'error' ){
						$('.article-search-results').append(`
							<div class="article-search-result-single">
								<a>`+v+`</a>
							</div>
						`);
					}else{
						$.each(v, function(index, value){
							$('.article-search-results').prepend(`
								<div class="article-search-result-single">
									<a href="/headlines/article/`+value.slug+`" rel="`+value.slug+`">`+value.title+`</a>
								</div>
							`);
						});
					}
				});
			}
		}); 
	});
	
	$(window).ready(function(e){
		var current = $('.headline-links-wrap').scrollLeft();
		var half_total_width = ($('.headline-links-wrap').width()) / 2;
		var left = $('.headline-type-links.active').position().left; 
		if( half_total_width < left ){
			$('.headline-links-wrap').scrollLeft(current + left);	
		}
	});
});